import { render, staticRenderFns } from "./Anexos18Page.vue?vue&type=template&id=25576ed8"
import script from "./Anexos18Page.js?vue&type=script&lang=js&external"
export * from "./Anexos18Page.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports